export default __webpack_public_path__ + "static/media/5_2.2b2d2179.jpg";